import { Injectable, OnInit } from "@angular/core";
import { HttpClient, HttpHeaders, HttpRequest } from "@angular/common/http";
import {
  AppConfigService,
  AppConfig,
} from "../../../services/app-config.service";
import { AuthService } from "../../../auth/auth.service";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { ResponseContentType } from "@angular/http";

@Injectable()
export class ImportsService implements OnInit {
  public appConfig: AppConfig = new AppConfig();

  constructor(
    private authService: AuthService,
    private http: HttpClient,
    private appConfigService: AppConfigService
  ) {
    this.appConfig = this.appConfigService.getConfig();
  }

  ngOnInit(): void {}

  getResults(id: string, includeItems: boolean): Observable<any> {
    

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      "api/imports/status/" +
      id +
      "?includeResults=" +
      (includeItems ? "true" : "false");

    if (environment.debug_mode) {
      console.log("getResults url: " + url);
    }

    return this.http.get<any>(url);
  }

  getImoprtSummaryUrl(id: string): Observable<any> {
    

    let url: string = "";

    url = this.appConfig.oc_api_url + "api/imports/import-summary/" + id;

    if (environment.debug_mode) {
      console.log("getResults url: " + url);
    }

    return this.http.get<any>(url);
  }

  postJson(cmd: any, importType: number): Observable<any> {
    

    let url: string = "";

    if (importType == 1 || importType == 3) {
      url = this.appConfig.oc_api_url + "api/imports/member";
    }

    if (importType == 2) {
      url = this.appConfig.oc_api_url + "api/imports/patientprocedure";
    }

    if (importType == 4) {
      url = this.appConfig.oc_api_url + "api/imports/memberupsert";
    }

    if (importType == 5) {
      url = this.appConfig.oc_api_url + "api/imports/reminder";
    }

    if (importType == 6) {
      url = this.appConfig.oc_api_url + "api/imports/center";
    }

    if (environment.debug_mode) {
      console.log("postJson url: " + url);
    }
    if (importType == 1) {
      return this.http.post<any>(url, cmd);
    }
    if (importType == 2) {
      return this.http.post<any>(url, cmd);
    }
    if (importType == 3) {
      return this.http.put<any>(url, cmd);
    }
    if (importType == 4) {
      return this.http.post<any>(url, cmd);
    }
    if (importType == 5) {
      return this.http.post<any>(url, cmd);
    }
    if (importType == 6) {
      return this.http.post<any>(url, cmd);
    }
  }

  downloadPatientUploadTemplate(): Observable<any> {
    

    let url: string = "";

    url = this.appConfig.oc_api_url + "api/imports/patient-upload-template";

    return this.http.get(url, { responseType: "arraybuffer" });
  }

  uploadPatientsExcel(fileToUpload: File): Observable<any> {
    

    let url: string = "";

    url = this.appConfig.oc_api_url + "api/imports/patient-upload-excel";

    const formData = new FormData();

    formData.append("file", fileToUpload);

    const uploadRequest = new HttpRequest("POST", url, formData);

    return this.http.request(uploadRequest);
  }

  getResultsList(currentPage: number, pageLimit: number, includeStats: boolean, from: string, to: string, type: string): Observable<any> {
    

    let url: string = "";

    url = type == "All" ?
    `${this.appConfig.oc_api_url}api/imports/status-list?currentPage=${currentPage}&includeStats=${includeStats}&pageLimit=${pageLimit}&from=${from}&to=${to}`
    :
     `${this.appConfig.oc_api_url}api/imports/status-list?currentPage=${currentPage}&includeStats=${includeStats}&pageLimit=${pageLimit}&from=${from}&to=${to}&type=${type}`;

    if (environment.debug_mode) {
      console.log("getResults url: " + url);
    }

    return this.http.get<any>(url);
  }
}
